import { render, staticRenderFns } from "./template-edit.vue?vue&type=template&id=53abb8aa&scoped=true&"
import script from "./template-edit.vue?vue&type=script&lang=ts&"
export * from "./template-edit.vue?vue&type=script&lang=ts&"
import style0 from "./template-edit.vue?vue&type=style&index=0&id=53abb8aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53abb8aa",
  null
  
)

export default component.exports